module.exports = __webpack_public_path__ + "static/media/ic_line_inverse.3dd32e48.svg";